import { applyTheme } from 'cf-style-container';
import BoxUnstyled from './Box';
import BoxTheme from './BoxTheme';

var Box = applyTheme(BoxUnstyled, BoxTheme);

export { BoxUnstyled, Box, BoxTheme };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-box/es/index.js
// module id = 329
// module chunks = 0